import React from 'react';
import {get} from 'lodash';
import axios from 'axios';

import {
  requestCallback,
  CSRF_TOKEN,
} from '../lib/helpers';

const UserDeviceTools = ({
  deviceIds,
}) => {
  const bulkDelete = () => {
    if (confirm('Are you sure you want to delete?')) {
      requestCallback(axios.delete(`/${gon.currentProvider}/api/bulk/devices`, {
        data: {
          ids: deviceIds,
          authenticity_token: CSRF_TOKEN
        }
      }))
    }
  }

  const bulkClearPushToken = () => {
    if (confirm('Are you sure you want to clear?')) {
      requestCallback(axios.post(`/${gon.currentProvider}/api/bulk/devices/clear_push_info`, {
        ids: deviceIds,
        authenticity_token: CSRF_TOKEN
      }))
    }
  }

  const bulkClearVoipToken = () => {
    if (confirm('Are you sure you want to clear?')) {
      requestCallback(axios.post(`/${gon.currentProvider}/api/bulk/devices/clear_voip_push_info`, {
        ids: deviceIds,
        authenticity_token: CSRF_TOKEN
      }))
    }
  }

  return (
    <React.Fragment>
      <div className='TableChecker__left__ban-choices'>
        {gon.currentAdmin.isSuperAdmin &&
          <React.Fragment>
            <a
              onClick={bulkClearPushToken}
              disabled={deviceIds.length == 0}
              className='Badge Badge--wide Badge--gray'
            >
              Clear push info
            </a>

            <a
              onClick={bulkClearVoipToken}
              disabled={deviceIds.length == 0}
              className='Badge Badge--wide Badge--gray'
            >
              Clear VoIP push info
            </a>
          </React.Fragment>
        }

        <a
          onClick={bulkDelete}
          disabled={deviceIds.length == 0}
          className='Badge Badge--wide Badge--gray Badge--icon-trash'
        >
          Delete
        </a>
      </div>
    </React.Fragment>
  )
}

export default UserDeviceTools
